import { Component, OnInit } from '@angular/core';
import { DecamoneyService } from '../../../providers/decamoney.service';
import { LoaderEvent } from '../../../providers/loader-event';
import { ActivatedRoute } from '@angular/router';
import { ExcelService } from '../../../providers/excel.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

import * as moment from 'moment';
import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-transactions-list',
  templateUrl: './transactions-list.component.html',
  styleUrls: ['./transactions-list.component.css']
})
export class TransactionsListComponent implements OnInit {
  datePickerConfig: Partial<BsDatepickerConfig>;
  public tempPdf: any;
  public transactions:Array<any> = [];
  public users:Array<any> = [];
  public filtered:Array<any> = [];
  public filter: any = { from: '', to: ''};
  public allDeposits:Array<any> = [];
  public allWithdrawals:Array<any> = [];
  public allCoupons:Array<any> = [];
  public inputUser = '';
  public couponOnly:String = '';
  public sourceOnly:String = '';
  public searched:Array<any> = [];
  public dateRange = [];
  public companies:Array<any> = [];
  constructor(
    public route: ActivatedRoute,
    public decamoneyS: DecamoneyService,
    public excel: ExcelService,
    public loader: LoaderEvent) {
      this.loader.fire(true);
  }

  ngOnInit() {
    this.getTransactions(1);
    this.getAllUsers(1);
    this.getDeposits(1);
    this.getWithdrawals(1);
    this.getCoupons();
    this.getAllCompanies(1);
  }

  getCoupons(){
    this.decamoneyS.getAllCoupons()
      .then((res:any) => {
        this.allCoupons = res;
      });
  }

  getTransactions(page){
    this.decamoneyS.getOrders('transfers', page)
      .then((res):any => {
        this.transactions = this.transactions.concat(res['orders'].filter(ord => ord.origin.currency != ord.destination.currency && ord.status == 'completed').sort((a,b):any => {
          if (a.updated_at < b.updated_at) return 1;
          else if (a.updated_at > b.updated_at) return -1;
          return 0;
        }));
        this.filtered = this.filtered.concat(res['orders'].filter(ord => ord.origin.currency != ord.destination.currency && ord.status == 'completed').sort((a,b):any => {
          if (a.updated_at < b.updated_at) return 1;
          else if (a.updated_at > b.updated_at) return -1;
          return 0;
        }));
        page++;
        if (res['orders'].length >= 100) {
          this.getTransactions(page);
        }
        this.loader.fire(false);
      });
  }

  estimatedTime(order){
    if (order.next) {
      let lastwith = this.allWithdrawals.find(draw => draw.id == order.next.id);
      if (lastwith) {
        let time = (new Date(lastwith.updated_at).getTime() / 1000) - (new Date(order.created_at).getTime() / 1000);
        var sec_num = parseInt(Math.floor(time).toString(), 10); // don't forget the second param
        var hours:any   = Math.floor(sec_num / 3600);
        var minutes:any = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds:any = sec_num - (hours * 3600) - (minutes * 60);

        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        return hours+':'+minutes+':'+seconds;
      } else {
        return '-'
      }
    } else {
      return '-'
    }
  }

  getDeposits(page?){
    this.decamoneyS.getOrders('deposits', page)
      .then((res) => {
        this.allDeposits = this.allDeposits.concat(res['orders'].filter(ord => ord.status == 'completed'));
        page++;
        if (res['orders'].length >= 100) {
          this.getDeposits(page);
        }
      });
  }

  getWithdrawals(page?){
    this.decamoneyS.getOrders('withdrawals', page)
      .then((res) => {
        this.allWithdrawals = this.allWithdrawals.concat(res['orders'].filter(ord => ord.status == 'completed'));
        page++;
        if (res['orders'].length >= 100) {
          this.getWithdrawals(page);
        }
      });
  }

  findSourceOfFounds(order){
    if (order.previous) {
      let source = this.allDeposits.filter(dep => dep.id == order.previous.id)[0]['source_funds'];
      order.srcFounds = source;
      return source?source:'-';
    }
    return '-'
  }

  getAllUsers(page?){
    this.decamoneyS.listUsers(page)
      .then((res):any => {
        this.users = this.users.concat(res['users']);
        page++;
        if (res['users'].length >= 100) {
          this.getAllUsers(page);
        }
      });
  }

  getAllCompanies(page?){
    this.decamoneyS.listCompanies(page)
      .then((res) => {
        this.companies = this.companies.concat(res);
        page ++;
        if (this.companies.length >= 100) {
          this.getAllCompanies(page);
        }
      })
  }

  cancelSearch(){
    this.transactions = JSON.parse(JSON.stringify(this.filtered));
    this.filter = {
      from: '',
      to: ''
    };
    this.inputUser = '';
    this.couponOnly = '';
    this.sourceOnly = '';
    this.searched = [];
  }

  newSearch(){
    let filteredArray = JSON.parse(JSON.stringify(this.filtered));
    if (this.dateRange[0] && this.dateRange[1]) {
      filteredArray = this.betweenDates(filteredArray, this.dateRange[0], this.dateRange[1]);
    }

    if (this.couponOnly) {
      if (this.couponOnly == 'all') {
        filteredArray = filteredArray.filter(tran => tran.coupon);
      } else {
        filteredArray = filteredArray.filter(tran => tran.coupon == this.couponOnly);
      }
    }

    if (this.sourceOnly) {
      if (this.sourceOnly == 'all') {
        filteredArray = filteredArray.filter(tran => tran.srcFounds);
      } else {
        filteredArray = filteredArray.filter(tran => tran.srcFounds == this.sourceOnly);
      }
    }

    if (this.inputUser) {
      filteredArray = filteredArray.filter(tran => this.findUser(tran.user_id).toLowerCase().includes(this.inputUser.toLowerCase()));
    }

    this.transactions = filteredArray;
    this.searched = filteredArray;
  }

  betweenDates(array, from, to){
    let dateFrom = moment(from).format("YYYY-MM-DD");
    let dateTo = moment(to).format("YYYY-MM-DD");
    for (let i = array.length - 1; i >= 0 ; i--) {
      let updated = moment(new Date(array[i].updated_at)).format("YYYY-MM-DD");
      if (moment(updated).isBetween(dateFrom,dateTo, null, "[]")) {
      } else {
        array.splice(i, 1);
      }
    }
    return array
  }

  userChange(evt) {
    this.transactions = JSON.parse(JSON.stringify(this.searched.length!=0?this.searched:this.filtered));
    if (evt) {
      this.transactions = this.transactions.filter(tran => this.findUser(tran.user_id).toLowerCase().includes(evt.toLowerCase()));
    }
  }

  findUser(id){
    for (let o = 0; o < this.users.length; o++) {
      if (this.users[o].id == id) {
        return `${this.users[o].name} ${this.users[o].lastname1} ${this.users[o].lastname2}`
      }
    }
  }

  findCompany(id) {
    for (let i = 0; i < this.companies.length; i++) {
      if (this.companies[i].id == id) {
        return this.companies[i].name
      }
    }
  }

  findDocumentUser(id){
    for (let o = 0; o < this.users.length; o++) {
      if (this.users[o].id == id) {
        return `${this.users[o].doc_type.toUpperCase()} : ${this.users[o].doc_number}`
      }
    }
  }

  findRucCompany(id) {
    for (let i = 0; i < this.companies.length; i++) {
      if (this.companies[i].id == id) {
        return 'RUC : ' + this.companies[i].ruc
      }
    }
  }

  exportXLSX() {
    let headers = ['Fecha', 'Cliente', 'Documento', 'Compra/Venta Decamoney' ,'Monto PEN', 'Monto USD', 'Monto USD', 'Monto PEN', 'Tipo de cambio', 'Cupón usado', 'Tiempo estimado'];
    let data = [];
    for (var i = 0; i < this.transactions.length; i++) {
      let originFix = (Number(this.transactions[i].origin.amount)).toFixed(2);
      let destinationFix = (Number(this.transactions[i].destination.amount)).toFixed(2);
      let toData = [moment(this.transactions[i].updated_at).format('DD MMM YYYY'), this.findUser(this.transactions[i].user_id), this.findDocumentUser(this.transactions[i].user_id) , this.transactions[i].origin.currency=='PEN'?'Venta':'Compra', this.transactions[i].origin.currency=='PEN'?`S/${originFix}`:'-', this.transactions[i].origin.currency=='PEN'?`$${originFix}`:'-', this.transactions[i].origin.currency=='USD'?`$${originFix}`:'-', this.transactions[i].origin.currency=='USD'?`S/${destinationFix}`:'-', Number(this.transactions[i].exchange_rate).toFixed(4), this.transactions[i].coupon?this.transactions[i].coupon:'-', this.estimatedTime(this.transactions[i])];
      data.push(toData);
    }
    this.excel.generateExcel('Transacciones', headers, data);
  }

  downloadPDF(){
    this.tempPdf = {
      pageSize: 'A4',
      pageMargins: [22,10,22,0],
      content: [],
      pageBreakBefore: function(
        currentNode,
        followingNodesOnPage,
        nodesOnNextPage,
        previousNodesOnPage
      ){
        return currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0;
      }
    };
    this.tempPdf.content.push({
      table: {
        widths: ['auto', '*'],
        headerRows: 0,
        body: [
          [
            { image: 'data:image/png;base64,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', width: 100 },
            { text: [this.filter.from&&this.filter.to?`Transacciones del ${moment(this.filter.from).format('DD MMM YYYY')} al ${moment(this.filter.to).format('DD MMM YYYY')}`:'Transacciones'], style: ['header-title'] }
          ]
        ]
      },
      layout: 'noBorders'
    });
    let sum = {
      originPen: 0,
      originUsd: 0,
      destinationPen: 0,
      destinationUsd: 0
    };
    let tabla = {
      style: 'table-normal',
      table: {
        widths: ['auto', 'auto', '10%', 'auto', 'auto', 'auto', 'auto', '8%', 'auto', '8%'],
        body: [
          [
            {
              text: 'Fecha',
              border: [true, true, true, true],
              style: ['table-orders-header'],
              fillColor: '#333'
            },
            {
              text: 'Cliente',
              border: [true, true, true, true],
              style: ['table-orders-header'],
              fillColor: '#333'
            },
            {
              text: 'Compra/Venta Decamoney',
              border: [true, true, true, true],
              style: ['table-orders-header'],
              fillColor: '#333'
            },
            {
              text: 'Monto PEN',
              border: [true, true, true, true],
              style: ['table-orders-header'],
              fillColor: '#333'
            },
            {
              text: 'Monto USD',
              border: [true, true, true, true],
              style: ['table-orders-header'],
              fillColor: '#333'
            },
            {
              text: 'Monto USD',
              border: [true, true, true, true],
              style: ['table-orders-header'],
              fillColor: '#333'
            },
            {
              text: 'Monto PEN',
              border: [true, true, true, true],
              style: ['table-orders-header'],
              fillColor: '#333'
            },
            {
              text: 'Tipo de cambio',
              border: [true, true, true, true],
              style: ['table-orders-header'],
              fillColor: '#333'
            },
            {
              text: 'Cupón usado',
              border: [true, true, true, true],
              style: ['table-orders-header'],
              fillColor: '#333'
            },
            {
              text: 'Tiempo estimado',
              border: [true, true, true, true],
              style: ['table-orders-header'],
              fillColor: '#333'
            }
          ]
        ]
      }, // end tabla
      layout: {
        hLineWidth: function(i, node) {
          return 0.5;
        },
        vLineWidth: function(i, node) {
          return 0.5;
        },
        hLineColor: function(i, node) {
          return '#b9b9c0';
        },
        vLineColor: function(i, node) {
          return '#b9b9c0';
        }
      }
    };
    for (let i = 0; i < this.transactions.length; i++) {
      let originFix = (Number(this.transactions[i].origin.amount)).toFixed(2);
      let destinationFix = (Number(this.transactions[i].destination.amount)).toFixed(2);
      if (this.transactions[i].origin.currency=='PEN') {
        sum.originPen += Number(this.transactions[i].origin.amount);
        sum.destinationUsd += Number(this.transactions[i].destination.amount);
      } else if(this.transactions[i].origin.currency=='USD') {
        sum.originUsd += Number(this.transactions[i].origin.amount);
        sum.destinationPen += Number(this.transactions[i].destination.amount);
      }
      tabla.table.body.push([
        {
          text: moment(this.transactions[i].updated_at).format('DD MMM YYYY'),
          border: [true, true, true, true],
          style: ['table-orders-body-small'],
          fillColor: '#ffffff'
        },
        {
          text: this.findUser(this.transactions[i].user_id) + '\n' + this.findDocumentUser(this.transactions[i].user_id),
          border: [true, true, true, true],
          style: ['table-orders-body'],
          fillColor: '#ffffff'
        },
        {
          text: this.transactions[i].origin.currency=='PEN'?'Venta':'Compra',
          border: [true, true, true, true],
          style: ['table-orders-body'],
          fillColor: '#ffffff'
        },
        {
          text: this.transactions[i].origin.currency=='PEN'?`S/${originFix}`:'-',
          border: [true, true, true, true],
          style: ['table-orders-body'],
          fillColor: '#ffffff'
        },
        {
          text: this.transactions[i].origin.currency=='PEN'?`$${destinationFix}`:'-',
          border: [true, true, true, true],
          style: ['table-orders-body'],
          fillColor: '#ffffff'
        },
        {
          text: this.transactions[i].origin.currency=='USD'?`$${originFix}`:'-',
          border: [true, true, true, true],
          style: ['table-orders-body'],
          fillColor: '#ffffff'
        },
        {
          text: this.transactions[i].origin.currency=='USD'?`S/${destinationFix}`:'-',
          border: [true, true, true, true],
          style: ['table-orders-body'],
          fillColor: '#ffffff'
        },
        {
          text: Number(this.transactions[i].exchange_rate).toFixed(4),
          border: [true, true, true, true],
          style: ['table-orders-body'],
          fillColor: '#ffffff'
        },
        {
          text: this.transactions[i].coupon?this.transactions[i].coupon:'-',
          border: [true, true, true, true],
          style: ['table-orders-body'],
          fillColor: '#ffffff'
        },
        {
          text: this.estimatedTime(this.transactions[i]),
          border: [true, true, true, true],
          style: ['table-orders-body'],
          fillColor: '#ffffff'
        }
      ]);
    };
    tabla.table.body.push([
      {
        text: '',
        border: [true, true, true, true],
        style: ['table-orders-footer'],
        fillColor: '#333'
      },
      {
        text: '',
        border: [true, true, true, true],
        style: ['table-orders-footer'],
        fillColor: '#333'
      },
      {
        text: '',
        border: [true, true, true, true],
        style: ['table-orders-footer'],
        fillColor: '#333'
      },
      {
        text: 'S/' + sum.originPen.toFixed(2),
        border: [true, true, true, true],
        style: ['table-orders-footer'],
        fillColor: '#333'
      },
      {
        text: '$' + sum.destinationUsd.toFixed(2),
        border: [true, true, true, true],
        style: ['table-orders-footer'],
        fillColor: '#333'
      },
      {
        text: '$' + sum.originUsd.toFixed(2),
        border: [true, true, true, true],
        style: ['table-orders-footer'],
        fillColor: '#333'
      },
      {
        text: 'S/' + sum.destinationPen.toFixed(2),
        border: [true, true, true, true],
        style: ['table-orders-footer'],
        fillColor: '#333'
      },
      {
        text: '',
        border: [true, true, true, true],
        style: ['table-orders-footer'],
        fillColor: '#333'
      },
      {
        text: '',
        border: [true, true, true, true],
        style: ['table-orders-footer'],
        fillColor: '#333'
      },
      {
        text: '',
        border: [true, true, true, true],
        style: ['table-orders-footer'],
        fillColor: '#333'
      }
    ]);
    this.tempPdf.content.push(tabla);
    this.addStyles(this.tempPdf);
    pdfMake
      .createPdf(this.tempPdf)
      .download(`test.pdf`);
  }


  addStyles(tempPdf) {
    tempPdf.styles = {
      'table-normal': {
        margin: [0, 5, 0, 15]
      },
      header: {
        fontSize: 10,
        bold: true,
        margin: [0, 10, 0, 0]
      },
      'table-orders-header': {
        fontSize: 8,
        bold: true,
        margin: [3, 3, 3, 3],
        alignment: 'center',
        color: '#ffffff'
      },
      'table-orders-body': {
        fontSize: 8,
        bold: false,
        margin: [3, 3, 3, 6],
        alignment: 'center',
        color: '#000000'
      },
      'table-orders-footer': {
        fontSize: 8,
        bold: true,
        margin: [3, 3, 3, 3],
        alignment: 'center',
        color: '#ffffff'
      },
      'table-orders-body-small': {
        fontSize: 6,
        bold: false,
        margin: [3, 3, 3, 6],
        alignment: 'center',
        color: '#000000'
      },
      aleft: {
        alignment: 'left'
      },
      aright: {
        alignment: 'right'
      },
      anotherStyle: {
        alignment: 'center'
      },
      dateStyle: {
        fontSize: 17
      },
      noteStyle: {
        alignment: 'right'
      },
      'header-title': {
        fontSize: 16,
        bold: true,
        alignment: 'center',
        margin: [0, 10, 0, 0]
      },
    };
  }
}